/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Share_Offer_Milestone_TitleInputs */

const en_us2_share_offer_milestone_title = /** @type {(inputs: Share_Offer_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} workouts! Want to show it?`)
};

const pt_br2_share_offer_milestone_title = /** @type {(inputs: Share_Offer_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} treinos! Que tal mostrar?`)
};

const es_419_share_offer_milestone_title = /** @type {(inputs: Share_Offer_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¡${i?.count} entrenamientos! ¿Lo muestras?`)
};

const pt_pt2_share_offer_milestone_title = /** @type {(inputs: Share_Offer_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} treinos! Que tal mostrar?`)
};

const fr_fr2_share_offer_milestone_title = /** @type {(inputs: Share_Offer_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} séances ! Tu le montres ?`)
};

const de_de2_share_offer_milestone_title = /** @type {(inputs: Share_Offer_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Trainings! Willst du's zeigen?`)
};

const it_it2_share_offer_milestone_title = /** @type {(inputs: Share_Offer_Milestone_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} allenamenti! Vuoi mostrarlo?`)
};

/**
* | output |
* | --- |
* | "{count} workouts! Want to show it?" |
*
* @param {Share_Offer_Milestone_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_offer_milestone_title = /** @type {((inputs: Share_Offer_Milestone_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Offer_Milestone_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_offer_milestone_title(inputs)
	if (locale === "es-419") return es_419_share_offer_milestone_title(inputs)
	if (locale === "pt-PT") return pt_pt2_share_offer_milestone_title(inputs)
	if (locale === "fr-FR") return fr_fr2_share_offer_milestone_title(inputs)
	if (locale === "de-DE") return de_de2_share_offer_milestone_title(inputs)
	if (locale === "it-IT") return it_it2_share_offer_milestone_title(inputs)
	return en_us2_share_offer_milestone_title(inputs)
});
export { share_offer_milestone_title as "share.offer_milestone_title" }